<template>
  <div>
    <div v-if="data">
      <h4>{{ "query_was_sent" | setText("Запрос отправлен на контроль") }}</h4>

      <ul class="mb-4" v-if="message && message.length">
        <li v-for="(m, k) in message" :key="k">
          <h5 class="text-danger">{{ m.text }}</h5>
        </li>
      </ul>

      <h2 v-if="timer > 0">
        {{ "wait_60_second" | setText("Ожидайте: ") }} {{ timer }}
        {{ "second" | setText("сек.") }}
      </h2>

      <button v-else class="btn btn-info mw" @click="sendRequest">
        {{ "check_status" | setText("Проверить статус") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify, toFormData } from "@/plugins/functions";

export default {
  methods: {},
  data: () => ({
    cartificate: null,
    message: [],
    timer: 0,
  }),
  props: ["value", "data", "type"],
  methods: {
    async sendRequest() {
      this.$loading(true);
      const action = `devices/${this.data.id}`;
      const url = this.data.service.api_endpoint_url + action;
      const token = this.data.service.api_token;
      const method = "get";
      return this.$http({
        method: method,
        url: url,
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": `application/json`,
          "Vendor-Code": `cb`,
        },
      })
        .then((response) => {
          this.$loading(false);
          let state = "";
          if (response && response.data) {
            try {
              const data = response.data.data;
              if (data && data.length) {
                let DoneCount = 0;
                let warning = false;

                for (let i = 0; i < data.length; i++) {
                  if (data[i].status === "done") {
                    DoneCount++;
                  }

                  if (
                    data[i].status === "warning" ||
                    data[i].status === "error"
                  ) {
                    switch (data[i].command) {
                      case "attach":
                        let logs = data[i].transaction_logs;

                        let imeis = [];
                        for (let j = 0; i < logs.length; i++) {
                          imeis = [...logs[i].body.imeis];
                        }

                        this.message.push({
                          text: `Ошибка установки на контроль: ${JSON.stringify(
                            imeis
                          )}`,
                        });
                        break;

                      default:
                        this.message.push({
                          text: `Ошибка установки на контроль. Обратитесь в тех. поддержку CB. ${JSON.stringify(
                            imeis
                          )}`,
                        });
                        break;
                    }
                  }
                }

                setTimeout(() => {
                  state = data.length === DoneCount ? "done" : "sent";
                  this.$emit("input", {
                    state: state,
                  });
                }, 100);

                if (state === "done") {
                  logger(this.$http, {
                    name: `Устройство на контроле - BSS`,
                    description: "",
                    model_type: this.type,
                    model_id: this.data.id,
                  });
                }
              }
            } catch (error) {
              //console.log(error);
            }

            this.$notify({
              title: "Ответ от системы",
              message:
                state == "done"
                  ? "Успешно установлено на контроль"
                  : "Не установлено на контроль. Ожидайте...",
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });
          }
        })
        .catch((error) => {
          this.$loading(false);
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          this.timer = 60;
        });
    },
  },

  mounted() {
    setInterval(() => {
      this.timer--;
    }, 1000);
  },
};
</script>

 